import { CurrencyUtil, ModelRow, StringUtil } from "@mcleod/core";
import { DataDisplayEvent, DataSourceExecutionEvent, DataSourceModeChangeEvent } from "@mcleod/components";
import { LMEGeneralSettings } from "@mcleod/general";
import { AutogenLayoutTargetPay } from "./autogen/AutogenLayoutTargetPay";

export class TargetPay extends AutogenLayoutTargetPay {
    /** This is an event handler for the afterModeChange event of sourceMovement.  */
    sourceMovementAfterModeChange(event: DataSourceModeChangeEvent) {
        if (this.mainDataSource.parentDataSource) {
            this.replaceMainDatasource(this.mainDataSource.parentDataSource);
        }
    }

    sourceMovementAfterExecute(event: DataSourceExecutionEvent) {
        if (event.data) {
            this.setupMpact(event.data);
        }
    }

    public setupMpact(move: ModelRow) {
        if (!move) {
            this.mpactRatingEnabled(false);
            return;
        }

        const originalRate = move.getCurrency("target_pay");
        const overrideValue = move.getCurrency("override_targetpay", null);
        if (move.get("target_pay_method") === "S"
        && (overrideValue == null || CurrencyUtil.currenciesAreEqual(overrideValue, originalRate))) {
            this.mpactRatingEnabled(true);
        } else {
            this.mpactRatingEnabled(false);
        }
    }

    mpactRatingEnabled(enabled: boolean) {
        const dispatchControl = LMEGeneralSettings.getSingleton().getDispatchControl();
        if (dispatchControl.target_pay_calc == "M" &&
            !StringUtil.isEmptyString(dispatchControl.mpact_smart_api_key) &&
            !StringUtil.isEmptyString(dispatchControl.mpact_host_url)) {
            this.panelMPact.visible = enabled;
            this.textboxTargetPayCalc.captionVisible = !enabled;
        }
    }


    textboxTargetPayCalcOnDataDisplay(event: DataDisplayEvent) {
        if (this.activeRow) {
            this.setupMpact(this.activeRow);
        }
    }
}
